import {
  RichText,
  Outer,
  Centred,
  Contents,
  Develop,
  Dynamics,
  Devops,
  MainFloat,
  Margins
} from './mixins/'
import { yellow } from '@material-ui/core/colors'

const styles = theme => ({
  // --------------------------------------------------------------------------
  // errors
  // --------------------------------------------------------------------------

  errorPage: {
    position: 'absolute',
    margin: 0,
    width: '100%',
    height: '100vh'
  },

  error404: {
    height: '100%',
    '& h1': {
      display: 'block',
      fontWeight: 800,
      color: 'rgba(255,255,255,1)'
    },
    '& h3': {
      display: 'block',
      fontWeight: 400,
      color: 'rgba(255,255,255,1)'
    }
  },

  // --------------------------------------------------------------------------
  // General
  // --------------------------------------------------------------------------

  outer: {
    ...Outer(theme)
  },
  centred: {
    ...Centred(theme)
  },
  contents: {
    ...Contents(theme)
  },
  mainFloat: {
    ...MainFloat(theme)
  },
  margins: {
    ...Margins(theme)
  },

  pinned: {
    height: '100%',
    width: '100%',
    top: 'auto',
    left: 'auto',
    bottom: 'auto',
    right: 'auto',
    margin: 0,
    display: 'block',
    boxSizing: 'content-box',
    paddingTop: 0,
    paddingBottom: 0,
    position: 'absolute',
    zIndex: 1
  },
  inner: {
    position: 'fixed',
    margin: 'auto',
    top: '0',
    left: '0',
    bottom: 'auto',
    right: 'auto',
    boxSizing: 'border-box',
    height: '100%',
    width: '100%'
  },
  main: {
    marginBottom: theme.spacing.unit * 10,
    height: '100%',
    minHeight: '70vh',
    display: 'flex',
    justifyContent: 'center'
  },

  shadow: {
    boxShadow: '10px 10px 5px 0px rgba(0,0,0,0.75)'
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    width: '50%'
  },

  title: {
    textAlign: 'left',
    maxWidth: '100%'
  },

  // --------------------------------------------------------------------------
  // Home - video bg, logo, text
  // --------------------------------------------------------------------------

  cookieBanner: {
    backgroundColor: 'rgba(72, 72, 72,.7)',
    height: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cookieMessage: {
    fontFamily: 'sans-serif',
    fontSize: '1.5rem'
  },
  cookieButton: { display: 'none' },

  front: {
    position: 'absolute',
    top: 0
  },
  frontMatter: {
    zIndex: 2,
    position: 'relative',
    background: 'rgba(255,255,255,1)'
  },
  frontOpener: {
    textAlign: 'center',
    width: '75%',
    maxWidth: 1024
  },
  frontLogo: {
    maxWidth: 1024,
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.up('sm')]: {
      width: '75%'
    }
  },
  frontStrap: {
    marginTop: -theme.spacing.unit * 3,
    fontSize: theme.typography.body2.fontSize,
    letterSpacing: 1.4,
    fontWeight: 500,
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,1)'
  },
  frontDown: {
    cursor: 'pointer',
    position: 'absolute',
    bottom: '5%',
    width: '100%',
    textAlign: 'center',
    '& img': {
      width: 40,
      [theme.breakpoints.up('sm')]: {
        width: 40
      }
    }
  },

  sectionOver: {
    transform: 'translateY(-400px)',
    marginBottom: '-300px'
  },

  // --------------------------------------------------------------------------
  // Home - lead text
  // --------------------------------------------------------------------------

  lead: {
    height: '100vh',
    '& $leadHead, & $leadSub': {
      textTransform: 'uppercase'
    }
    // backgroundImage: theme.brand && theme.brand.home.lead.backgroundGradient,
  },
  leadSub: {
    fontSize: theme.typography.body2.fontSize,
    color: '#858585',
    letterSpacing: '1.4px'
  },
  leadHead: {
    color: 'rgb(19, 191, 222)',
    fontSize: theme.typography.display1.fontSize,
    fontWeight: 800,
    letterSpacing: 2,
    lineHeight: 1,
    [theme.breakpoints.down('xs')]: {
      fontSize: 30
    }
  },

  // --------------------------------------------------------------------------
  // Home - services
  // --------------------------------------------------------------------------

  services: {
    height: '100%',
    minHeight: '100vh',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center'
  },
  servicesLogoWrapper: {
    padding: 10,
    margin: 'auto',
    maxWidth: 150,
    '& img': {
      height: 100
    }
  },
  servicesItem: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing.unit * 8,
    '& img': {
      padding: theme.spacing.unit,
      marginBottom: theme.spacing.unit * 2
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: 0
    }
  },
  servicesHead: {
    textTransform: 'uppercase',
    // fontSize: theme.typography.subheading.fontSize,
    marginBottom: theme.spacing.unit * 2,
    letterSpacing: '1.65px'
    // fontWeight: 800,
  },
  servicesContent: {
    flexGrow: 1,
    '& p': {
      // fontSize: '1rem',
      margin: 'auto',
      fontWeight: 100,
      [theme.breakpoints.up('sm')]: {
        paddingLeft: '2rem',
        paddingRight: '2rem'
      }
      // justifyContent: 'center',
      // alignItems: 'center',
    }
  },
  servicesButtonLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.8rem',
    fontWeight: 400
  },
  servicesButton: {
    display: 'inline-block',
    display: 'inline-block',
    textUnderlinePosition: 'under',
    color: theme.palette.common.white,
    marginTop: theme.spacing.unit * 5,
    // fontWeight: theme.typography.fontWeightRegular,
    minWidth: '100px'
  },
  serviceButton_datascience: {
    // ...Develop(theme).background,
    backgroundImage: theme.brand && theme.brand.datascience.backgroundGradient
  },
  serviceButton_develop: {
    // ...Develop(theme).background,
    backgroundImage: theme.brand && theme.brand.develop.backgroundGradient
  },
  serviceButton_dynamics_365: {
    // ...Dynamics(theme).background,
    backgroundImage: theme.brand && theme.brand.dynamics_365.backgroundGradient
  },
  serviceButton_devops: {
    // ...Devops(theme).background,
    backgroundImage: theme.brand && theme.brand.devops.backgroundGradient
  },

  // --------------------------------------------------------------------------
  // Home - methodology
  // --------------------------------------------------------------------------

  methodology: {
    background: '#fff',
    height: '100%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing.unit * 10,
    paddingBottom: theme.spacing.unit * 10,
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing.unit * 3,
      paddingBottom: theme.spacing.unit * 3
    }
  },
  methodologySubtitle: {
    textTransform: 'uppercase',
    fontSize: theme.typography.body2.fontSize,
    color: '#333',
    letterSpacing: '1.4px'
  },
  methodologyTitle: {
    fontSize: theme.typography.display1.fontSize,
    textTransform: 'uppercase',
    lineHeight: 1,
    fontWeight: 800
  },

  methodologyItem: {
    height: 500,
    width: 500,
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      '&:nth-child(2)': {
        alignSelf: 'flex-end',
        marginLeft: -500,
        marginTop: -150
      }
    },
    [theme.breakpoints.down('md')]: {
      flexGrow: 1,
      maxWidth: '100vw'
    }
  },

  methodologyContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'left',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center'
    }
  },

  methodologyTaas: {
    padding: '1rem',
    borderLeft: '1px solid #555',
    borderTop: '1px solid #555',
    background: '#333333',
    boxShadow: '5px 5px 2px 0px rgba(171,171,171,1)',
    '-webkit-box-shadow': '5px 5px 2px 0px rgba(171,171,171,1)',
    '-moz-box-shadow': '5px 5px 2px 0px rgba(171,171,171,1)',
    '&:hover': {
      backgroundImage:
        'linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)'
    }
  },
  methodologyFixed: {
    padding: '1rem',
    background: '#333333',
    boxShadow: '5px 5px 2px 0px rgba(171,171,171,1)',
    '-webkit-box-shadow': '5px 5px 2px 0px rgba(171,171,171,1)',
    '-moz-box-shadow': '5px 5px 2px 0px rgba(171,171,171,1)',
    '&:hover': {
      backgroundImage:
        'linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)'
    }
  },

  methodologyContent: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '& img': {
      width: 120,
      alignItems: 'center',
      marginBottom: theme.spacing.unit * 4
    },
    '& h2': {
      color: '#fff',
      fontSize: theme.typography.title.fontSize,
      marginBottom: theme.spacing.unit * 2,
      textTransform: 'uppercase'
    },
    '& h3': {
      color: '#fff'
    }
  },

  methodologyButton: {
    color: '#fff',
    border: '1px solid #fff',
    margin: theme.spacing.unit * 5
  },

  // --------------------------------------------------------------------------
  // Home - studies
  // --------------------------------------------------------------------------

  featuredStudies: {
    height: '100%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    // paddingTop: theme.spacing.unit * 10,
    paddingBottom: theme.spacing.unit * 10,
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing.unit * 3,
      paddingBottom: theme.spacing.unit * 3
    }
  },
  featuredStudiesSub: {
    textTransform: 'uppercase',
    fontSize: theme.typography.body2.fontSize,
    color: '#858585',
    letterSpacing: '1.4px'
  },
  featuredStudiesHead: {
    fontSize: theme.typography.display1.fontSize,
    textTransform: 'uppercase',
    lineHeight: 1,
    fontWeight: 800
  },

  // --------------------------------------------------------------------------
  // Home - careers
  // --------------------------------------------------------------------------

  careers: {
    height: '100%',
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center'
  },
  careersSub: {
    color: 'rgb(255,255,255)',
    fontSize: theme.typography.subheading.fontSize,
    textTransform: 'uppercase'
  },
  careersHead: {
    color: 'rgb(255,255,255)',
    textTransform: 'uppercase',
    fontSize: theme.typography.display1.fontSize,
    fontWeight: 800
  },
  careerDetails: {
    marginBottom: theme.spacing.unit * 3
  },
  careersRoleTitle: {
    color: 'rgb(255,255,255)',
    fontSize: theme.typography.headline.fontSize,
    lineHeight: 1
  },
  careersRoleDescription: {
    color: 'rgb(255,255,255)',
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 100,
    marginBottom: theme.spacing.unit * 5
  },
  careersIcon: {
    height: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 2,
    verticalAlign: 'sub',
    display: 'inline'
  },
  careersText: {
    display: 'inline',
    color: 'rgb(255,255,255)',
    fontSize: theme.typography.subheading.fontSize
  },
  careersContactLink: {
    marginTop: theme.spacing.unit * 5,
    fontSize: theme.typography.body1.fontSize,
    padding: 5,
    '& a': {
      color: 'rgba(255,255,255,1)',
      textUnderlinePosition: 'under'
    },
    '& span': {
      borderColor: theme.palette.common.white,
      color: theme.palette.common.white
    }
  },
  careerLinkButton: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.typography.caption.color,
    border: `1px solid rgba(255,255,255,1)`,
    // float: 'right',
    fontSize: '0.8rem'
  },

  // --------------------------------------------------------------------------
  // Home - blog
  // --------------------------------------------------------------------------

  blog: {
    // height: '150%',
    minHeight: '150vh',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing.unit * 10,
    marginBottom: theme.spacing.unit * 10,
    '& $postlistLink': {
      [theme.breakpoints.up('md')]: {
        position: 'absolute',
        bottom: 0,
        right: 0
      }
    }
  },

  blogHover: {
    '&:hover': {
      background: 'rgba(200,200,200,.1)'
    }
  },

  blogContain: {
    // paddingTop: '16rem',
  },
  blogSub: {
    textTransform: 'uppercase',
    fontSize: theme.typography.body2.fontSize,
    color: '#858585',
    letterSpacing: '1.4px'
    // fontSize: '1rem',
    // color: '#444',
  },
  blogHead: {
    fontSize: theme.typography.display1.fontSize,
    textTransform: 'uppercase',
    fontWeight: 800
  },
  blogAuthorMug: {
    float: 'left',
    width: 70,
    marginRight: theme.spacing.unit,
    marginLeft: -theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      width: 50
    }
  },
  blogAuthor: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: '500',
    color: '#323232'
  },
  blogLead: {
    marginTop: theme.spacing.unit * 5,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 100
  },
  blogItemTitle: {
    marginTop: theme.spacing.unit * 3,
    // letterSpacing: '2px',
    textTransform: 'uppercase',
    fontSize: theme.typography.subheading.fontsize
  },
  blogNavLink: {
    fontSize: theme.typography.body1.fontSize,
    padding: 5,
    '& a': {
      color: '#333',
      textUnderlinePosition: 'under'
    },
    '& img': {
      width: 20,
      display: 'inline',
      verticalAlign: 'middle',
      marginRight: 10,
      marginLeft: -8
    }
  },
  blogSlider: {
    marginTop: theme.spacing.unit * 7,
    marginBottom: theme.spacing.unit * 2
  },
  blogNav: {
    height: 150,
    '& :hover': {
      background: '#fafafa',
      cursor: 'pointer'
    }
  },
  blogNavHeader: {
    fontSize: theme.typography.subheading.fontSize,
    marginTop: -theme.spacing.unit
  },
  blogNavContent: {
    display: 'inline',
    position: 'absolute',
    padding: 15,
    lineHeight: 1
  },
  blogNavText: {
    fontWeight: 100
  },
  blogNavThumb: {
    display: 'inline'
  },
  blogItemPad: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '1rem',
      position: 'relative'
    }
  },
  blogItemImgPad: {
    paddingRight: 20
  },
  blogItemNorm: {
    // marginTop: theme.spacing.unit * 3,
    [theme.breakpoints.up('md')]: {
      position: 'relative'
    }
  },
  blogDate: {
    marginBottom: theme.spacing.unit * 3,
    fontSize: '1rem',
    letterSpacing: '0.7px',
    textTransform: 'uppercase',
    color: '#323232'
  },
  blogLead: {
    fontSize: '1.2rem',
    marginBottom: theme.spacing.unit * 3
  },
  blogThumb: {
    marginBottom: theme.spacing.unit * 2
  },
  // postlistLink: {
  //   fontSize: theme.typography.caption.fontSize,
  //   color: theme.typography.caption.color,
  //   border: `1px solid ${theme.typography.caption.color}`,
  //   float: 'right',
  //   fontSize: '0.8rem',
  // },
  postLinkButton: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.typography.caption.color,
    border: `1px solid ${theme.typography.caption.color}`,
    // float: 'right',
    fontSize: '0.8rem'
  },

  // --------------------------------------------------------------------------
  // Home - clients
  // --------------------------------------------------------------------------

  clients: {
    // height: '100%',
    // minHeight: '70vh',
    // display: 'flex',
    // alignItems: 'center',

    height: '100%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing.unit * 10,
    paddingBottom: theme.spacing.unit * 10,
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing.unit * 3,
      paddingBottom: theme.spacing.unit * 3
    }
  },
  clientsIcons: {
    marginTop: theme.spacing.unit * 4,
    marginLeft: -theme.spacing.unit * 8,
    justifyContent: 'space-between',
    '& img': {
      width: 300,
      [theme.breakpoints.down('sm')]: {
        width: 250
      }
    },
    [theme.breakpoints.down('sm')]: {
      margin: `${theme.spacing.unit * 8}px auto 0`,
      justifyContent: 'space-around'
    }
  },
  clientIconImg: {
    maxWidth: 200,
    marginBottom: theme.spacing.unit * 2
  },
  clientsSub: {
    color: 'rgb(255,255,255)',
    textTransform: 'uppercase',
    fontSize: theme.typography.body2.fontSize
  },
  clientsHead: {
    color: 'rgb(255,255,255)',
    lineHeight: 1,
    textTransform: 'uppercase',
    fontSize: theme.typography.display1.fontSize,
    fontWeight: 800
  },
  // clientIcons: {
  //   marginTop: theme.spacing.unit * 5,
  // },

  // --------------------------------------------------------------------------
  // Careers
  // --------------------------------------------------------------------------

  // careers: {
  //   marginTop: theme.spacing.unit * 5,
  //   marginBottom: theme.spacing.unit * 10,
  // },
  careerPaper: {
    marginBottom: theme.spacing.unit * 5
  },
  career: {
    paddingTop: '2rem',
    paddingBottom: '5rem',
    paddingLeft: '3rem',
    paddingRight: '3rem',
    maxWidth: 1024,
    '& h1': {
      fontWeight: 800,
      color: 'rgba(0,0,0,.7)'
    }
  },
  careerInfo: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 3,
    '& img': {
      width: 25,
      height: 30,
      background: 'rgba(0,0,0,.5)',
      borderRadius: 5,
      padding: 5,
      verticalAlign: 'top',
      marginRight: 10
    }
  },
  careerForm: {
    marginLeft: 20
  },
  careersApply: {
    marginTop: theme.spacing.unit * 3
  },
  careersSubmit: {
    marginTop: theme.spacing.unit * 3
  },
  careersFilter: {
    paddingTop: '4rem',
    maxWidth: 1024,
    '& h1': {
      color: 'rgba(0,0,0,.7)'
    }
  },
  careerFilter: {
    '& div': {
      marginRight: theme.spacing.unit * 2,
      fontWeight: 100
    }
  },
  careerFilterReset: {
    cursor: 'pointer',
    textDecoration: 'underline',
    underlinePosition: 'under'
  },
  careerDetails: {
    ...RichText(theme)
  },

  // --------------------------------------------------------------------------
  // Blogs
  // --------------------------------------------------------------------------

  teaser: {
    height: '100%'
  },

  focus: {
    marginBottom: theme.spacing.unit * 5
  },
  focusFloat: {
    background: '#D6407D',
    marginTop: -220,
    width: '45%',
    position: 'relative',
    padding: '4rem',
    marginLeft: 55
  },
  focusFloatStudies: {
    background: '#D6407D'
  },
  focusFloatBlog: {
    background: '#5897E4'
  },
  focusSub: {
    color: theme.palette.common.white,
    fontSize: theme.typography.subheading.fontSize,
    fontWeight: 800,
    textTransform: 'uppercase'
  },
  focusText: {
    color: theme.palette.common.white,
    fontSize: theme.typography.body2.fontSize
  },
  focusLink: {
    marginTop: theme.spacing.unit * 3,
    fontSize: theme.typography.caption.fontSize,
    '& a': {
      color: 'rgba(255,255,255,1)',
      textUnderlinePosition: 'under'
    },
    '& span:first-of-type': {
      color: theme.palette.common.white
    },
    '& span:last-of-type': {
      padding: 5,
      border: `1px solid`,
      borderColor: theme.palette.common.white
    }
  },
  postlistLink: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.typography.caption.color,
    border: `1px solid ${theme.typography.caption.color}`,
    float: 'left'
  },
  postlist: {
    height: '100%',
    minHeight: '90vh',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  posts: {
    overflowX: 'hidden',
    overflowY: 'hidden'
  },
  postItem: {
    padding: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 5
  },
  postThumbnail: {
    paddingTop: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  postItemTitle: {
    marginTop: theme.spacing.unit * 3,
    textTransform: 'uppercase',
    fontSize: theme.typography.subheading.fontsize
  },
  postAuthor: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.typography.body1.color
  },
  postlistText: {
    margin: `${theme.spacing.unit * 2}px 0`
  },

  // --------------------------------------------------------------------------
  // Blog / Studies Nav
  // --------------------------------------------------------------------------

  blogStudyNavItems: {
    background: theme.brand && theme.brand.develop.backgroundGradient,
    height: '100%',
    minHeight: '70vh',
    '& h3, p, img': {
      color: 'rgba(255,255,255,1)'
    }
  },
  blogStudyNavTitle: {
    padding: '1rem',
    fontWeight: 800,
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,1)'
  },
  blogStudyItemHead: {
    color: 'rgba(255,255,255,1)',
    fontWeight: 400
  },
  blogStudyItemSub: {
    color: 'rgba(255,255,255,.5)',
    fontWeight: 100
  },
  blogStudyNavIcon: {
    maxHeight: 55,
    verticalAlign: 'top',
    opacity: 0.5
  },

  // --------------------------------------------------------------------------
  // Studies
  // --------------------------------------------------------------------------

  teaser: {
    height: '100%'
  },

  studylist: {
    height: '100%',
    minHeight: '90vh',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },

  studylistLink: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.typography.caption.color,
    border: `1px solid ${theme.typography.caption.color}`,
    float: 'left'
  },

  studies: {
    overflowY: 'hidden',
    overflowX: 'hidden'
  },
  studyItem: {
    padding: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 5
  },
  studyThumbnail: {
    paddingTop: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  studylistText: {
    margin: `${theme.spacing.unit * 2}px 0`
  },
  studyEnd: {
    height: theme.spacing.unit * 10
  },

  // --------------------------------------------------------------------------
  // Contact
  // --------------------------------------------------------------------------

  channels: {
    marginBottom: theme.spacing.unit * 10,
    height: '100%',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center'
    // '& h1, h2, h3, p': { color: 'rgba(255,255,255,1)' },
  },

  channelTitle: {
    fontWeight: 800,
    textTransform: 'uppercase'
  },

  channelList: {
    marginTop: theme.spacing.unit * 10
  },

  channelListItem: {
    marginTop: theme.spacing.unit * 5
  },

  contactForm: {
    marginBottom: theme.spacing.unit * 10,
    height: '100%',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center'
    // '& h1, h3, label, input': { color: 'rgba(255,255,255,1)' },
  },

  contactLink: {
    color: 'rgba(0,0,0,.5)',
    textUnderlinePosition: 'under'
  },

  contactLinkWhite: {
    color: 'rgba(255,255,255,.7)'
  },

  contactFormField: {
    marginRight: theme.spacing.unit * 2
  },

  contactFormSubmit: {
    marginTop: theme.spacing.unit * 5
  },

  offices: {
    marginBottom: theme.spacing.unit * 10,
    height: '100%',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    '& h1, h2, h3, p': { color: 'rgba(255,255,255,1)' }
  },

  officeTitle: {
    fontWeight: 800,
    textTransform: 'uppercase'
  },

  officeAddress: {
    marginTop: theme.spacing.unit * 5
  },
  officeAddressText: {
    ...RichText(theme)
  },

  officeAddressTheme_red: {
    paddingTop: theme.spacing.unit * 5
    // background: '#ffe7e7',
    // backgroundImage: theme.brand && theme.brand.devops.backgroundGradient,
    // padding: theme.spacing.unit * 5,
  },

  officeAddressTheme_green: {
    paddingTop: theme.spacing.unit * 5
    // background: '#dee4de',
    // backgroundImage: theme.brand && theme.brand.develop.backgroundGradient,
    // padding: theme.spacing.unit * 5,
    // minHeight: 400,
  },

  // --------------------------------------------------------------------------
  // Contact
  // --------------------------------------------------------------------------

  aboutMetrics: {
    height: '70%',
    minHeight: '70vh',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center'
  },
  aboutMetricsTitle: {
    '& h1': {
      fontWeight: 800,
      textTransform: 'uppercase',
      marginTop: theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit * 2,
      lineHeight: 1
    }
  },
  aboutMetricsGrid: {
    '& h1': {
      fontWeight: 100,
      fontSize: theme.typography.headline.fontSize,
      marginTop: theme.spacing.unit * 2
    },
    '& h3': {
      // fontWeight: 800,
      fontSize: theme.typography.body2.fontSize,
      margin: theme.spacing.unit * 2,
      color: theme.palette.grey[600]
    }
  },
  aboutMetric: {
    minWidth: 200,
    width: 210,
    background: theme.palette.grey[100],
    padding: theme.spacing.unit,
    borderRadius: theme.spacing.unit,
    margin: theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  },
  aboutStory: {
    height: '70%',
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    '& h1': {
      fontWeight: 800,
      textTransform: 'uppercase'
    }
  },
  aboutStoryText: {
    marginLeft: theme.spacing.unit * 3,
    ...RichText(theme)
  },
  aboutLinks: {
    height: '50%',
    minHeight: '50vh',
    display: 'flex',
    alignItems: 'center',
    '& h1': {
      fontWeight: 800,
      textTransform: 'uppercase'
    }
  },
  aboutLinkItem: {
    marginRight: theme.spacing.unit * 3,
    '& a': {
      textDecoration: 'none'
    },
    '& span': {
      fontWeight: 100
    }
  },
  aboutLinkGroup: {
    paddingLeft: theme.spacing.unit * 6,
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing.unit * 5
    }
  },
  findOutMoreButton: {
    display: 'inline-block',
    display: 'inline-block',
    textUnderlinePosition: 'under',
    color: theme.palette.common.white,
    marginTop: theme.spacing.unit * 5,
    // fontWeight: theme.typography.fontWeightRegular,
    minWidth: '100px',
    backgroundImage: theme.brand && theme.brand.dynamics_365.backgroundGradient,
    fontSize: '1.5rem',
    lineHeight: '1.2em',
  },
  findOutMore: {
    textAlign: 'center',
  },

  // --------------------------------------------------------------------------
  // Things
  // --------------------------------------------------------------------------

  thingsItemsList: {
    marginBottom: theme.spacing.unit * 10
  },
  thingsItem: {
    marginTop: theme.spacing.unit * 5,
    padding: theme.spacing.unit * 2,
    // background: '#f8f7f7',
    borderRadius: 4
  },
  thingsItemLogo: {
    width: 175,
    height: 175
  },
  thingsItemTitle: {
    color: theme.palette.grey[600],
    fontWeight: 400,
    // textTransform: 'uppercase',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    lineHeight: 1
  },
  thingsItemText: {},
  thingsItemButton: {
    marginTop: theme.spacing.unit * 2,
    '& a': {
      fontSize: '.75rem'
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/styles/site.js